import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import "./Navbar.scss";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Logo from "../../../components/Logo";
import Languages from "../../../components/Languages";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {logoutUser} from '../../../redux/slices/authSlice'

const Navbar = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const { t } = useTranslation('global');
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const handleLogout = () => {
      dispatch(logoutUser());
      navigate("/prelogin");
  }
  return (
    <div className="navbar">
      <div className="wrapper">
        <div >
          <div style={{ paddingLeft: '1rem', margin: 10 }}>
            <Logo width={'100'} height={'80'} />
          </div>

        </div>
        <div className="items">
          <Typography sx={{ fontSize: '1.5rem', fontWeight: 600 }} component={'div'}>
            {t('welcome')} {userInfo.firstName} {userInfo.lastName}!&nbsp;&nbsp;&nbsp;
          </Typography>
          <div className="item">
            <LanguageOutlinedIcon className="icon" />
            <span>English</span>
            <Languages />
          </div>
          <div className="item">
                <Button sx={{ width:100}}  variant="contained" className='btn'  onClick={handleLogout}>Logout</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
